module.exports = __webpack_public_path__ + "img/zy-title7.5aa4e7ba.png";